type BuildStackedBarChartAxisLineSxParams = {
  dividerColor: string;
  hideXAxisLine: boolean;
  hideYAxisLine: boolean;
};

type AxisLineStyle = {
  stroke: string;
};

type StackedBarChartAxisLineSx = Record<string, AxisLineStyle>;

export const buildStackedBarChartAxisLineSx = ({
  dividerColor,
  hideXAxisLine,
  hideYAxisLine,
}: BuildStackedBarChartAxisLineSxParams): StackedBarChartAxisLineSx => ({
  '& .MuiChartsAxis-directionX .MuiChartsAxis-line, & .MuiChartsAxis-directionX .MuiChartsAxis-line[stroke]':
    hideXAxisLine
      ? {
          stroke: 'transparent !important',
        }
      : {
          stroke: `${dividerColor} !important`,
        },
  '& .MuiChartsAxis-directionY .MuiChartsAxis-line, & .MuiChartsAxis-directionY .MuiChartsAxis-line[stroke]':
    hideYAxisLine
      ? {
          stroke: 'transparent !important',
        }
      : {
          stroke: `${dividerColor} !important`,
        },
});
